import { MonthlySalesSummaryItem } from '../../features/pricebook/types/items';

class MonthlySalesSummaryEntryModel {
  private _serverData: any;
  private _periodKey: string;

  constructor(periodKey: string, serverData: any = null) {
    this._periodKey = periodKey;
    this._serverData = serverData;
  }

  get period_key() {
    return this._periodKey;
  }

  get month() {
    return String(this._serverData?.month || '');
  }

  get qty() {
    return Number(this._serverData?.qty ?? 0);
  }

  get rate() {
    return Number(this._serverData?.rate ?? 0);
  }

  get value() {
    return Number(this._serverData?.value ?? 0);
  }

  get formattedMonthLabel() {
    const [year, month] = this.period_key.split('-');
    if (!year || !month) {
      return this.month || this.period_key;
    }

    const monthIndex = Number(month) - 1;
    const date = new Date(Number(year), monthIndex, 1);
    if (Number.isNaN(date.getTime())) {
      return this.month || this.period_key;
    }

    return date.toLocaleDateString('en-US', {
      month: 'long',
      year: 'numeric',
    });
  }

  toRowFormat(): MonthlySalesSummaryItem {
    return {
      month: this.formattedMonthLabel,
      qty: this.qty,
      rate: Number(this.rate.toFixed(2)),
      value: Number(this.value.toFixed(2)),
    };
  }

  static fromServerData(periodKey: string, serverData: any) {
    return new MonthlySalesSummaryEntryModel(periodKey, serverData);
  }
}

class MonthlySalesSummaryModel {
  private _serverData: any;
  private _entries: MonthlySalesSummaryEntryModel[];

  constructor(serverData: any = null) {
    this._serverData = serverData;
    const months = serverData?.months && typeof serverData.months === 'object' ? serverData.months : {};
    this._entries = Object.entries(months)
      .sort(([leftKey], [rightKey]) => rightKey.localeCompare(leftKey))
      .map(([periodKey, value]) => MonthlySalesSummaryEntryModel.fromServerData(periodKey, value));
  }

  get store_id() {
    return String(this._serverData?.store_id || '');
  }

  get scan_code() {
    return String(this._serverData?.scan_code || '');
  }

  get months() {
    return this._entries;
  }

  toRowsFormat(): MonthlySalesSummaryItem[] {
    return this._entries.map((entry) => entry.toRowFormat());
  }

  static fromServerData(serverData: any) {
    return new MonthlySalesSummaryModel(serverData);
  }

  static createEmpty() {
    return new MonthlySalesSummaryModel({ months: {} });
  }
}

export default MonthlySalesSummaryModel;
export { MonthlySalesSummaryEntryModel };
